import { Spin, Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import { FilterText } from 'components/FilterDiv'
import ChartIcon from 'components/Images/Chat_Circle_Close.svg'
import EditIcon from 'components/Images/Edit_Pencil_Line_02.svg'
import PocAvail from 'components/Images/Poc_Avail.svg'
import Pagination from 'components/Pagination'
import { StyledTable } from 'components/TableStyles/GroupTable'
import ColoredTooltip from 'components/UIComponents/ColoredTooltip'
import { StyledSearchInput } from 'components/UIComponents/GroupTableSearchFilter'
import React, { useState } from 'react'
import DeleteBin from '../../../../../../../../../components/icons/DeleteBin'
import { TableTopper } from './style'

export const GroupTable = ({
  pageLimit = 10,
  pageNum = 1,
  setPageNum,
  setSelectedInstitute,
  selectedInstitute,
  instituteCampusList,
  onRemoveInstitutes,
  handleEditTier,
  handleEditPOC,
  totalItems,
  groupsInstituteCampusIds = [],
  onGroupFilterChange,
  groupInstFilterData,
  onPageChange,
  mode,
  handleSort,
  setSelectedInstituteData,
  // Optional external loading controls
  tableLoading: externalTableLoading,
  setTableLoading: externalSetTableLoading,
  searchValue,
  setSearchValue,
}) => {
  const [localTableLoading, setLocalTableLoading] = useState(false)
  const effectiveTableLoading = externalTableLoading ?? localTableLoading
  const setEffectiveTableLoading =
    externalSetTableLoading || setLocalTableLoading

  const columns = [
    {
      title: 'COLLEGE NAME',
      dataIndex: 'collegeName',
      width: '30%',
      render: (text, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            <>
              <AntdAvatar
                src={record.logo}
                size={36}
                IconName={
                  text && text.length > 0 ? text.trim()[0].toUpperCase() : '-'
                }
              />
              <span
                style={{
                  fontSize: 14,
                  lineHeight: '28px',
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontWeight: 500,
                  marginLeft: 4,
                }}
              >
                {text || '-'}
              </span>
            </>
          </span>
          {record.pilRecommended && (
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <div
                style={{
                  background: '#3249D7',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '2px 14px',
                  fontWeight: 700,
                  fontSize: 10,
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  letterSpacing: 0.2,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  width: 'fit-content',
                  height: 'fit-content',
                  minWidth: 40,
                  maxWidth: 120,
                  whiteSpace: 'nowrap',
                }}
              >
                PIL Recc.
              </div>
            </span>
          )}
        </div>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      render: (text, record) => {
        const city = record?.city || '-'
        const state = record?.state || '-'
        return `${city}, ${state}`
      },
    },
    {
      title: 'Tier',
      dataIndex: 'tier',
      key: 'tier',
      align: 'center',
      sorter: (a, b) => {
        const tierA = a?.corporateDetails?.tier || a?.tier || 0
        const tierB = b?.corporateDetails?.tier || b?.tier || 0
        return tierA - tierB
      },
      render: (tier, record) => {
        let backgroundColor = '#eee'
        let color
        let border
        switch (tier) {
          case 1:
            backgroundColor = '#FFE5ED'
            color = '#964D65'
            border = '1px solid #964D65'
            break
          case 2:
            backgroundColor = '#E7E0FF'
            color = '#7D64DA'
            border = '1px solid #7D64DA'
            break
          case 3:
            backgroundColor = '#E0F7FF'
            color = '#55A1BA'
            border = '1px solid #55A1BA'
            break
          case 4:
            backgroundColor = '#E0FFE5'
            color = '#58B981'
            border = '1px solid #58B981'
            break
          default:
            backgroundColor = '#e0e0e0'
        }
        return (
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}
          >
            <div
              style={{
                backgroundColor,
                color,
                border,
                borderRadius: '15px',
                padding: '4px 12px',
                minWidth: '80px',
                fontWeight: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Tier {tier || '-'}
            </div>
            <Tooltip title="Edit">
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => handleEditTier(record, true)}
              >
                <img
                  src={EditIcon}
                  alt="Edit"
                  style={{ width: 30, height: 30 }}
                />
              </div>
            </Tooltip>
          </div>
        )
      },
    },
    {
      title: 'Action Items',
      key: 'actions',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          {!record?.pocDetails?.length ? (
            <ColoredTooltip title="POC" coloredTitle="NA" color="#E35E50">
              <div
                style={{ fontSize: '16px', cursor: 'pointer' }}
                onClick={() => handleEditPOC(record, true)}
              >
                <img
                  src={ChartIcon}
                  alt="No POC"
                  style={{ width: 35, height: 35, cursor: 'pointer' }}
                  onClick={() => handleEditPOC(record, true)}
                />
              </div>
            </ColoredTooltip>
          ) : (
            <ColoredTooltip title="POC" coloredTitle="Avail." color="#58B981">
              <div
                style={{ fontSize: '16px', cursor: 'pointer' }}
                onClick={() => handleEditPOC(record, true)}
              >
                <img
                  src={PocAvail}
                  alt="POC Available"
                  style={{ width: 29, height: 29, cursor: 'pointer' }}
                  onClick={() => handleEditPOC(record, true)}
                />
              </div>
            </ColoredTooltip>
          )}
        </div>
      ),
    },
  ]

  const handleCollegeSelectChange = (selectedRowKeys, selectedRows) => {
    // Update selectedInstitute to persist across pages
    setSelectedInstitute(prevIds => {
      // Remove unchecked
      const filtered = prevIds.filter(id => selectedRowKeys.includes(id))
      // Add new checked (avoid duplicates)
      const newChecked = selectedRowKeys.filter(id => !filtered.includes(id))
      return [...filtered, ...newChecked]
    })

    // Update selectedInstituteData to persist across pages
    setSelectedInstituteData(prevRows => {
      // Remove unchecked
      const filtered = prevRows.filter(row =>
        selectedRowKeys.includes(row.id)
      )
      // Add new rows (avoid duplicates)
      const newRows = selectedRows.filter(
        row =>
          !filtered.some(r => r.id === row.id)
      )
      return [...filtered, ...newRows]
    })
  }

  // Handler for single row select
  const handleSingleRowSelect = (record, selected) => {
    setSelectedInstitute(prev => {
      if (selected) {
        return prev.includes(record.id)
          ? prev
          : [...prev, record.id]
      } else {
        return prev.filter(id => id !== record.id)
      }
    })

    setSelectedInstituteData(prev => {
      if (selected) {
        return prev.some(r => r.id === record.id)
          ? prev
          : [...prev, record]
      } else {
        return prev.filter(
          r => r.id !== record.id
        )
      }
    })
  }

  // Handler for select all on page
  const handleSelectAllRows = (selected, selectedRows, changeRows) => {
    const changeIds = changeRows.map(r => r.id)
    setSelectedInstitute(prev => {
      if (selected) {
        return Array.from(new Set([...prev, ...changeIds]))
      } else {
        return prev.filter(id => !changeIds.includes(id))
      }
    })

    setSelectedInstituteData(prev => {
      if (selected) {
        const newRows = changeRows.filter(
          r => !prev.some(pr => pr.id === r.id)
        )
        return [...prev, ...newRows]
      } else {
        return prev.filter(r => !changeIds.includes(r.id))
      }
    })
  }

  const rowSelection = {
    selectedRowKeys: selectedInstitute,
    onSelect: handleSingleRowSelect,
    onSelectAll: handleSelectAllRows,
    getCheckboxProps: record => {
      return {
        disabled: groupsInstituteCampusIds?.includes(record.instituteCampusId),
        name: record.collegeName,
      }
    },
  }

  const handleRemoveInstitutes = async () => {
    setEffectiveTableLoading(true)
    try {
      await onRemoveInstitutes(true) // parent callback should return a promise
    } finally {
      setEffectiveTableLoading(false)
    }
  }

  return (
    <>
      <TableTopper centerVertically>
        <StyledSearchInput
          width={'70%'}
          placeholder={'Search by college name'}
          bordered={false}
          searchValue={searchValue}
          setSearchValue={val => 
          {
            setSearchValue(val)
            onGroupFilterChange(val, 'search')
          }}
        />
        <div
          style={{
            marginBottom: '-8px',
          }}
        >
          <DeleteBin
            onClick={handleRemoveInstitutes}
            disabled={!selectedInstitute || selectedInstitute.length === 0}
          />
        </div>
        <FilterText>
          Showing {Math.min(pageNum * pageLimit, totalItems)} of {totalItems}
        </FilterText>
      </TableTopper>
      <div style={{ position: 'relative', minHeight: 200 }}>
        {effectiveTableLoading && (
          <div
            style={{
              position: 'absolute',
              zIndex: 2,
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(255,255,255,0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spin />
          </div>
        )}
        <StyledTable
          columns={columns}
          dataSource={instituteCampusList ?? []}
          rowSelection={rowSelection}
          rowKey="id"
          bordered
          width="100%"
          pagination={false}
          onChange={(pagination, filters, sorter) => {
            const tableType = mode
              ? mode == 'default'
                ? 'draftSelect'
                : 'addToGroup'
              : 'groupInstitute'
            handleSort(pagination, filters, sorter, tableType)
          }}
        />
      </div>
      <Pagination
        onChange={(page, pageSize) =>
          onPageChange(
            mode
              ? mode == 'default'
                ? 'draftSelect'
                : 'addToGroup'
              : 'groupInstitute',
            page,
            pageSize
          )
        }
        totalPages={totalItems}
        pageSize={pageLimit}
        current={pageNum}
      />
    </>
  )
}

export default GroupTable
